export const Information = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="16" r="13" stroke="currentColor" stroke-width="2"/>
<path d="M13 15H16V23" stroke="currentColor" stroke-width="2"/>
<path d="M12 23H20" stroke="currentColor" stroke-width="2"/>
<circle cx="16" cy="9.5" r="1" fill="currentColor" stroke="currentColor"/>
</svg>`;
